import { Typography } from 'antd'
import AttributeSegmentationList from 'app/components/Core/CategorySegment/AttributeSegmentation/List'
import { useFeedbacker } from 'app/lib/contexts/Feedbacker'
import * as React from 'react'

import { MemberProps } from '../../convention'

const AttributeSegmentationLink: React.FC<MemberProps<Partial<ICategorySegment>>> = ({
  children,
  member
}) => {
  const {
    modalify: { open }
  } = useFeedbacker()

  const onAttributeSegmentationsClick = () => {
    open({
      title: member.name,
      content: <AttributeSegmentationList member={member} />,
      footer: <span />
    })
  }

  return <Typography.Link onClick={onAttributeSegmentationsClick}>{children}</Typography.Link>
}

export default AttributeSegmentationLink
